import { render, staticRenderFns } from "./BookmakersDetails.vue?vue&type=template&id=1e12431e&"
import script from "./BookmakersDetails.vue?vue&type=script&lang=ts&"
export * from "./BookmakersDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports